import { useEffect, useRef, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  discardPrevNoc,
  handleLoadNocDocument,
  loadInitNocPrevData,
  saveUnprocessedNoc,
} from "../../../store/actions/userPackagesActions";
import IntroModal from "./documentNocComponents/IntroModal";
import { currentProcessingNocFileBase } from "../../../data/userPackage/prepareNoc";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

const CustomDocumentsPrepareNoc = () => {
  const stripe = useStripe();
  const elements = useElements();
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);
  const { customCreateNoc } = useSelector((state) => state.userPackages);

  const [currentProcessingFile, setCurrentProcessingFile] = useState(
    currentProcessingNocFileBase
  );
  const dispatch = useDispatch();

  const [packagePanelOpen, setPackagePanelOpen] = useState(true);


  const [loadInitNoc, setLoadInitNoc] = useState(false);

  const loadInitNocRef = useRef(false);

  const [discardNocLoading, setDiscardNocLoading] = useState(false);
  const [initNocLoading, setInitNocLoading] = useState(false);

  const [onBanner, setOnBanner] = useState(true);

  const [checkInitLoading, setCheckInitLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [notarizePrice, setNotarizePrice] = useState(0);
  const [recordPrice, setRecordPrice] = useState(0);
  const [notaryRecordPrice, setNotaryRecordPrice] = useState(0);

  const latestFileRef = useRef(currentProcessingFile);

  const handleDiscardInitNoc = async () => {
    try {
      setDiscardNocLoading(true);
      await dispatch(discardPrevNoc(customCreateNoc?.packageID));
      setLoadInitNoc(false);
    } catch (error) {
      console.error("Error discarding NOC:", error);
    } finally {
      setDiscardNocLoading(false);
    }
  };

  useEffect(() => {
    latestFileRef.current = currentProcessingFile;
  }, [currentProcessingFile]);

  useEffect(() => {
    if (currentUser) {
      const tiers = currentUser?.service_tiers;
      setNotarizePrice(tiers?.noc_notary);
      setRecordPrice("39");
      setNotaryRecordPrice(tiers?.notary_record);
    }
  }, [currentUser]);

  const handleLoadInitNoc = async () => {
    try {
      setInitNocLoading(true);
      const resp = await dispatch(
        handleLoadNocDocument(customCreateNoc?.packageID, currentProcessingFile)
      );
      if (resp?.success) {
        setCurrentProcessingFile(resp?.data);
        setOnBanner(false);
      }
    } catch (error) {
      console.error("Error loading NOC:", error);
    } finally {
      setInitNocLoading(false);
    }
  };

  const handleLoadFirstInitNoc = async () => {
    const fetched = await dispatch(loadInitNocPrevData());
    if (
      fetched?.data &&
      Object.keys(fetched?.data)?.length > 0 &&
      fetched?.data?.packageID &&
      !fetched?.data?.document?.tempFields &&
      !currentProcessingFile?.packageID
    ) {
      setLoadInitNoc(true);
    }
    setCheckInitLoading(false);
  };

  useEffect(() => {
    if (currentUser?.payment_cards && currentUser?.payment_cards?.length > 0) {
      setCards(
        currentUser?.payment_cards?.map((card) => {
          const lastTwo = String(card.exp_year).slice(-2);
          const first = card.exp_month;

          return {
            id: card.id,
            cardNum: "**** **** **** " + card.last4,
            cardName: card.name ? card.name : card.card_holder,
            expires:
              (first < 10 ? "0" + String(first) : String(first)) +
              "/" +
              lastTwo,
            default: card.default,
          };
        })
      );
    } else {
      setCards([]);
    }
  }, [currentUser?.payment_cards]);

  useEffect(() => {
    if (!loadInitNocRef?.current) {
      loadInitNocRef.current = true;
      handleLoadFirstInitNoc();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      if (latestFileRef.current?.packageID) {
        dispatch(saveUnprocessedNoc());
      }
    };
  }, [dispatch]);

  return (
    <DndProvider backend={HTML5Backend}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          overflow: "hidden", // Prevent global scrolling
          backgroundColor: "inherit",
        }}
      >
        {/* Main Content Area */}
        <Box
          sx={{
            my: "auto",
            flex: 1, // Take remaining space
            display: "flex",
            flexDirection: "column", // Arrange content vertically
            overflowY: "auto", // Allow scrolling for the main content
            height: "100%",
          }}
        >
          {/* {packagePanelOpen && ( */}
          <IntroModal
            setPackagePanelOpen={setPackagePanelOpen}
            packagePanelOpen={packagePanelOpen}
            currentProcessingFile={currentProcessingFile}
            setCurrentProcessingFile={setCurrentProcessingFile}
            // setAddingNewDocument={setAddingNewDocument}
            onBanner={onBanner}
            setOnBanner={setOnBanner}
            loadInitNoc={loadInitNoc}
            discardNocLoading={discardNocLoading}
            handleDiscardInitNoc={handleDiscardInitNoc}
            initNocLoading={initNocLoading}
            handleLoadInitNoc={handleLoadInitNoc}
            checkInitLoading={checkInitLoading}
            cards={cards}
            setCards={setCards}
            stripe={stripe}
            elements={elements}
            CardElement={CardElement}
            notarizePrice={notarizePrice}
            recordPrice={recordPrice}
            notaryRecordPrice={notaryRecordPrice}
          />
        </Box>
      </Box>
    </DndProvider>
  );
};

export default CustomDocumentsPrepareNoc;
